
<!-- 
<div class="page-content">
    <app-header></app-header>
    <app-home></app-home>
    <app-cv></app-cv>
    <app-projects></app-projects>
    <app-blogs></app-blogs>
    <app-services></app-services>

</div> -->
<div class="page-content">
<app-header></app-header>
<router-outlet></router-outlet>
</div>